/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Font_Preview_ParagraphInputs */

const en_onboarding_font_preview_paragraph = /** @type {(inputs: Onboarding_Font_Preview_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This formulation helps when we move to more complex domains like the Open Images Dataset [7]. In this dataset there are many overlapping labels (i.e. Woman and Person). Using a softmax imposes the assumption that each box has exactly one class which is often not the case. A multilabel approach better models the data.`)
};

const es_onboarding_font_preview_paragraph = /** @type {(inputs: Onboarding_Font_Preview_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta formulación ayuda cuando pasamos a dominios más complejos como el conjunto de datos Open Images [7]. En este conjunto de datos hay muchas etiquetas superpuestas (por ejemplo, Mujer y Persona). Usar softmax impone la suposición de que cada recuadro tiene exactamente una clase, lo cual a menudo no es el caso. Un enfoque multietiqueta modela mejor los datos.`)
};

/**
* | output |
* | --- |
* | "This formulation helps when we move to more complex domains like the Open Images Dataset [7]. In this dataset there are many overlapping labels (i.e. Woman a..." |
*
* @param {Onboarding_Font_Preview_ParagraphInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_font_preview_paragraph = /** @type {((inputs?: Onboarding_Font_Preview_ParagraphInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Font_Preview_ParagraphInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_font_preview_paragraph(inputs)
	return en_onboarding_font_preview_paragraph(inputs)
});